import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import Time from "react-time-format";
import { change_Lang } from "../../actions/Helper_action";
import he from "he";
import {
  Delete_Writer,
  Get_List_Writors,
  Update_Writer,
  View_Writer,
} from "../../actions/Invoice_action";
import Swal from "sweetalert2";
import { Editor } from "@tinymce/tinymce-react";
import { Modal, Input, Tooltip, Button } from "antd";
const ReListWriteForm = () => {
  const dispatch = useDispatch();
  const view_writer = useSelector((state) => state.InvoiceReducer.view_writer);
  useEffect(() => {
    dispatch(Get_List_Writors());
  }, []);
  useEffect(() => {
    setwriter(view_writer.writer);
    setforcompany(view_writer.forcompany);
    setsubject(view_writer.subject);
    setattachment(view_writer.attachment);
  }, [view_writer]);

  const [update_open, setupdate_open] = useState(false);
  const [writer, setwriter] = useState("");
  const [forcompany, setforcompany] = useState("");
  const [subject, setsubject] = useState("");
  const [update_close, setupdate_close] = useState(true);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const list_writer = useSelector((state) => state.InvoiceReducer.list_writer);
  const [attachment, setattachment] = useState("");

  const [IsModalVisible, setIsModalVisible] = useState(false);
  const showModal = (id) => {
    setIsModalVisible(true);
    dispatch(View_Writer(id));
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const onOpenUpdate = () => {
    setupdate_close(false);
    setupdate_open(true);
  };
  const onCloseUpdate = () => {
    const data = {
      writer,
      forcompany,
      subject,
      attachment,
    };
    dispatch(Update_Writer(view_writer._id, data));
    handleCancel();
    setupdate_close(true);
    setupdate_open(false);
    Swal.fire({
      title: "Good job!",
      html: `<b class="fk">${dispatch(
        change_Lang("You successfully tainted your work")
      )}</b>`,
      icon: "success",
      confirmButtonText: dispatch(change_Lang("success")),
      buttonsStyling: { fontFamily: "fk" },
      timer: 1000,
    });
  };
  const onDeleteWriter_Contract = (id) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label class="fk">${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Delete_Writer(id));
        dispatch(Get_List_Writors());
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
          timer: 1000,
        });
      }
    });
  };
  const datas = list_writer.map((el, i) => {
    return {
      id: i + 1,
      action: (
        <>
          <Tooltip title="View">
            <Button
              style={{ background: "#efefed", color: "#4064d7" }}
              shape="circle"
              onClick={() => showModal(el._id)}
              icon={
                <i
                  style={{
                    cursor: "pointer",
                  }}
                  className="fas fa-eye text-center mt-1"
                ></i>
              }
            />
          </Tooltip>
          &nbsp;
          <Tooltip title="Delete">
            <Button
              style={{ background: "#efefed", color: "#4064d7" }}
              shape="circle"
              onClick={() => onDeleteWriter_Contract(el._id)}
              icon={
                <i
                  style={{
                    cursor: "pointer",
                  }}
                  className="fas fa-ban text-center mt-1"
                ></i>
              }
            />
          </Tooltip>
        </>
      ),
      branchName: (
        <span className={`${lang === "en" ? "" : "fk"}`}>
          {el.branchId && el.branchId.name}
        </span>
      ),
      forcompany: (
        <span className={`${lang === "en" ? "" : "fk"}`}>{el.forcompany}</span>
      ),
      subject: (
        <span className={`${lang === "en" ? "" : "fk"}`}>{el.subject}</span>
      ),
      agent_name: (
        <span className={`${lang === "en" ? "" : "fk"}`}>{`${
          el.agentId && el.agentId.fname
        } ${el.agentId && el.agentId.lname}`}</span>
      ),
      date: (
        <Time
          value={el.createdAt}
          format="YYYY-MM-DD"
          style={{ color: "black" }}
          className={`${lang === "en" ? "" : "fk"}`}
        />
      ),
    };
  });
  const columns = [
    {
      name: dispatch(change_Lang("id")),
      selector: "id",
      sortable: true,
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Name of Branch")),
      selector: "branchName",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Agent_name")),
      selector: "agent_name",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("to")),
      selector: "forcompany",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("subject")),
      selector: "subject",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
      compact: true,
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("List of Scripts"))}
          parent={dispatch(change_Lang("List of Bills"))}
        />
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk"
          }`}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-12 ">
              <div className="card">
                <div className="row ">
                  <div className="col-md-3 card-header d-flex justify-content-start"></div>
                  <div className="col-md-6 card-header">
                    <div className=" text-center mt-2">
                      <h3 style={{ fontWeight: "bold", color: "#4064d7" }}>
                        {dispatch(change_Lang("List of Scripts"))}
                      </h3>
                    </div>
                  </div>
                  <div className="col-md-3 m-auto"></div>
                </div>
                <div className="row user-status table-responsive latest-order-table table-striped">
                  <div className="co-12">
                    <DataTable
                      customStyles={customStyles}
                      columns={columns}
                      data={datas}
                      pagination={true}
                      noDataComponent={dispatch(change_Lang("table_display"))}
                      striped
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title={dispatch(change_Lang("Request permission"))}
          className="fk"
          width={1200}
          open={IsModalVisible}
          onCancel={handleCancel}
          footer={false}
          bodyStyle={{ background: "#f6f8fa" }}
        >
          <div
            className={`${
              lang === "en" ? "container-fluid" : "container-fluid fk"
            }`}
          >
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-md-12">
                    <p
                      style={{
                        fontSize: "20px",
                        color: "black",
                        background: "white",
                        borderRadius: "10px",
                      }}
                      className="mb-4 d-none d-lg-flex justify-content-center text-uppercase p-1"
                    >
                      {dispatch(change_Lang("To write"))}
                    </p>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10">
                    {update_open !== true ? (
                      <p
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        {view_writer.forcompany}
                      </p>
                    ) : (
                      <Input
                        onChange={(e) => setforcompany(e.target.value)}
                        value={forcompany}
                        autoFocus
                        className="fk"
                        placeholder={change_Lang("to")}
                        style={{ fontSize: "18px", color: "black" }}
                      />
                    )}
                  </div>
                  <div className="col-1"></div>
                </div>
                <br />
                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10">
                    {update_open !== true ? (
                      <p
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        {view_writer.subject}
                      </p>
                    ) : (
                      <Input
                        onChange={(e) => setsubject(e.target.value)}
                        value={subject}
                        autoFocus
                        className="fk"
                        placeholder={change_Lang("subject")}
                        style={{ fontSize: "18px", color: "black" }}
                      />
                    )}
                  </div>
                  <div className="col-1"></div>
                </div>
                <br />
                {/* Text Area */}
                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10">
                    {update_open !== true ? (
                      <p
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "18px",
                            color: "black",
                            fontWeight: "bolder",
                          }}
                          className="fk"
                          dangerouslySetInnerHTML={{
                            __html: he.decode(`${view_writer.writer}`),
                          }}
                        ></div>
                      </p>
                    ) : (
                      <Editor
                        apiKey="7d56212666w1sh7f0o5xv8lebmo9tkfdpy1b0ozpud7zlfi2"
                        value={writer}
                        initialValue={he.decode(`${view_writer.writer}`)}
                        init={{
                          plugins:
                            "link image code table textcolor textpattern toc spellchecker advlist anchor emoticons fullpage fullscreen hr imagetools insertdatetime media wordcount save lists",
                          toolbar:
                            "undo redo | bold italic |fontselect| alignleft aligncenter alignright|fullscreen",
                          selector: "textarea",
                        }}
                        onEditorChange={(newValue, editor) => {
                          setwriter(newValue);
                          setwriter(editor.getContent({ format: "html" }));
                        }}
                      />
                    )}
                  </div>
                  <div className="col-1"></div>
                </div>
                <br />
                {/* attachment */}
                {view_writer.attachment !== "" ? (
                  <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10">
                      {update_open !== true ? (
                        <p
                          style={{
                            textAlign: "center",
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "18px",
                          }}
                        >
                          {view_writer.attachment}
                        </p>
                      ) : (
                        <Input
                          onChange={(e) => setattachment(e.target.value)}
                          value={attachment}
                          autoFocus
                          className="fk"
                          placeholder={change_Lang("Attachment")}
                          style={{ fontSize: "18px", color: "black" }}
                        />
                      )}
                    </div>
                    <div className="col-1"></div>
                  </div>
                ) : (
                  ""
                )}
                <br />
                <div className="row">
                  <div className="col-12 d-flex justify-content-center">
                    {update_close !== false ? (
                      <Button
                        className="ml-4 fk px-4"
                        type="primary"
                        shape="round"
                        style={{
                          background: "#d7e4eb",
                          color: "#4b85a4",
                          border: "none",
                          outline: "none",
                        }}
                        htmlType="submit"
                        onClick={onOpenUpdate}
                      >
                        {dispatch(change_Lang("profile_updatebt"))}&nbsp;
                        <i
                          className="fa fa-lock"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </Button>
                    ) : (
                      <Button
                        className="ml-4 fk px-4"
                        type="primary"
                        shape="round"
                        style={{
                          background: "#d7e4eb",
                          color: "#4b85a4",
                          border: "none",
                          outline: "none",
                        }}
                        htmlType="submit"
                        onClick={onCloseUpdate}
                      >
                        {dispatch(change_Lang("profile_updatebt"))}&nbsp;
                        <i
                          className="fa fa-lock-open"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    </>
  );
};

export default ReListWriteForm;
